export default "__VITE_PUBLIC_ASSET__06dc4a22__"